import type { ImageWithAnnotationProps } from "./image-with-annotation.type";

import { ImageWithData } from "@/ui/image-with-data";

import "./image-with-annotation.style.less";

export const ImageWithAnnotation = ({
  src,
  alt,
  svg,
}: ImageWithAnnotationProps) => {
  return (
    <ImageWithData
      src={src}
      alt={alt}
      data={
        <div
          className="image-with-annotation"
          dangerouslySetInnerHTML={{ __html: svg }}
        />
      }
    />
  );
};
